
<div class="get-care-now-title-container-web">{{title}}</div>
<div class="get-care-now-description-container-web">
    <div>{{description}}</div>
</div>
<div *ngIf="inpersonUrgentCareOptions != null && inpersonUrgentCareOptions.length > 0" class="get-care-now-scroll-container-web">
    <app-in-person-urgent-care-option-card
      *ngFor="let option of inpersonUrgentCareOptions"
      [providerId]="option.providerId"
      [departmentId]="option.departmentId"
      [name]="option.city"
      [photo]="option.photo"
      [waitTime]="option.waitTime"
      [nextAvailability]="option.nextAvailability"
      [isOpen]="option.isOpen"
      [address]="option.fullAddress"
      [distance]="option.distanceInMiles"
      [locale]="locale">
    </app-in-person-urgent-care-option-card>
</div>
<div *ngIf="inpersonUrgentCareOptions != null && inpersonUrgentCareOptions.length > 0" style="align-items: center; justify-content: center; display: flex; padding: 24px;">
    <button mat-button class="action-button-secondary" style="border-radius: 12px;" (click)="showMeMore()">{{showMoreText}}</button>
</div>
<div *ngIf="!inpersonUrgentCareOptions || inpersonUrgentCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>